/* eslint-disable @typescript-eslint/naming-convention */
import { DeviceModel, DeviceStatus } from '@shure/shared/angular/data-access/system-api/models';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
export interface DeviceManagementAnalyticsCommonEventInfo {}

export interface AnalyticsCommonDeviceInfo {
	model: DeviceModel;
	mac?: string;
	serial?: string;
	hardware_id?: string;
	network_status?: DeviceStatus;
}

export interface DeviceRowDataForAnalytics {
	hardwareId?: string;
	model: string;
	macAddress?: string;
	serialNumber?: string;
	deviceStatusCellData?: {
		status?: DeviceStatus;
	};
}

export enum AnalyticsLocation {
	// General
	PropertyPanel = 'property_panel',
	DevicesPage = 'devices_page',
	PendingPage = 'pending_page',
	JobsPage = 'jobs_page',
	CreateJobPage = 'create_job_page',
	JobDetailsPage = 'job_details_page',

	// Tables
	DevicesTable = 'devices_table',
	PendingTable = 'pending_table',
	JobsTable = 'jobs_table',
	CreateJobTable = 'create_job_table',
	JobDetailsTable = 'job_details_table',
	FirmwareUpdateDialogTable = 'firmware_update_dialog_table',

	// Dialogs
	FirmwareUpdateDialog = 'firmware_update_dialog',

	// DevicesPage
	UpdateSelectedButton = 'update_selected_button',

	// Scheduled Jobs
	JobsTableMenu = 'jobs_table_menu',
	JobsTableRowDoubleClick = 'jobs_table_row_double_click',
	JobDetailsEditButton = 'job_details_edit_button',
	StartJobNowButton = 'start_job_now_button'
}
